import { isAxiosError } from 'axios'
import { availabilityClient } from '../availability-client'

interface GetAvailabilityByOrderIdProps {
  postcode: string
  vehicleId: string
  collectionSiteId?: string
}

interface AvailabilitySlot {
  start: number
  end: number
  available: boolean
  hubId: string
}

export interface AvailabilitySlots {
  [date: string]: AvailabilitySlot[]
}

export const AvailabilityErrorCodes = {
  AddressNotFound: 'address-not-found',
  CannotDeliverToAddress: 'cannot-deliver-to-address',
} as const

export class AddressNotFoundError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'AddressNotFoundError'
  }
}

export class CannotDeliverToAddressError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'CannotDeliverToAddressError'
  }
}

export const getAvailability = async (props: GetAvailabilityByOrderIdProps) => {
  try {
    const { data } = await availabilityClient.get<AvailabilitySlots>(
      'availability',
      { params: props },
    )

    return data
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      switch (error.response.data?.code) {
        case AvailabilityErrorCodes.AddressNotFound: {
          throw new AddressNotFoundError(error.message)
        }
        case AvailabilityErrorCodes.CannotDeliverToAddress: {
          throw new CannotDeliverToAddressError(error.message)
        }
      }
    }

    throw error
  }
}
